import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetDepreciationSingleBaseReport  {
    _originalTypeClassName = "zERP.BO.AssetDepreciationSingleBaseReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetDepreciationSingleBaseReport.translate = translateService;
}
this.Category = null;
this.Type = null;
this.Method = null;
this.Percent = null;
this.UsefulLife = null;
this.LastDepreciation = null;
this.AcquisitionValue = null;
this.PreviousDepreciation = null;
this.CurrentDepreciation = null;
this.TotalDepreciation = null;
this.NonDepreciatedValue = null;
this.AssetDepreciationSingleBaseReportKey = null;
this._key = this.AssetDepreciationSingleBaseReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Category:any;
Type:any;
Method:any;
Percent:any;
UsefulLife:any;
LastDepreciation:any;
AcquisitionValue:any;
PreviousDepreciation:any;
CurrentDepreciation:any;
TotalDepreciation:any;
NonDepreciatedValue:any;
private _AssetDepreciationSingleBaseReportKey:any;
get AssetDepreciationSingleBaseReportKey(): any {
    return this._AssetDepreciationSingleBaseReportKey;
  }
set AssetDepreciationSingleBaseReportKey(value: any) {
    this._AssetDepreciationSingleBaseReportKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetDepreciationSingleBaseReportKey == null || $this.AssetDepreciationSingleBaseReportKey == 0;
            }


}